import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

const foreverSessionQuery = gql`
  query loginForeverSession {
    foreverSession {
      signonidentity {
        email
        signupType
      }
    }
  }
`;

export function useForeverSession() {
  const { data, loading } = useQuery(foreverSessionQuery);
  return {
    foreverSession: data?.foreverSession,
    isLoading: loading,
  };
}
